import type { SyntheticEvent } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { selectECommerceShoppingPlatforms } from "features/general/selectors";
import Resource from "ui/layouts/Resource";
import StatefulSelector from "ui/widgets/StatefulSelector";
import { Merchant } from "ui/forms/ECommerce";
import usePlatforms from "./usePlatforms";
import { getFormInputProps } from "util/forms";

const Platforms = () => {
    const {
        values,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        ...form
    } = usePlatforms();

    const onAutocompleteChange = (_: SyntheticEvent, values: string | Array<string>) => {
        setFieldValue(Merchant.BusinessInformation.FormField.Platforms, values, true);
        setTimeout(() => setFieldTouched(Merchant.BusinessInformation.FormField.Platforms, true));
    };

    return (
        <Resource
            breadcrumbsProps={{
                heading: 'Select the eCommerce platform you’d like to connect',
                links: [
                    {
                        name: ''
                    }
                ]
            }}
        >
            <Box
                component='form'
                onSubmit={handleSubmit}
                sx={{
                    maxWidth: 500,
                    display: 'grid',
                    gap: 2
                }}
            >
                <StatefulSelector
                    multiple
                    disablePortal
                    size='small'
                    layout={null}
                    selectOptions={selectECommerceShoppingPlatforms}
                    value={values.platforms}
                    onChange={onAutocompleteChange}
                    TextFieldProps={{
                        ...getFormInputProps(Merchant.BusinessInformation.FormField.Platforms, form),
                        label: 'Select E-Commerce platform',
                        name: Merchant.BusinessInformation.FormField.Platforms
                    }}
                />
                <Button
                    disabled={!values.platforms.length}
                    size='small'
                    type='submit'
                    variant='contained'
                    sx={{
                        width: 'fit-content',
                        justifySelf: 'flex-start'
                    }}
                >
                    Proceed
                </Button>
            </Box>
        </Resource>
    );
};

export default Platforms;
